module.exports = __webpack_public_path__ + "static/media/MyPendingTask.903e0b49.svg";